import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "speed-slider" }
const _hoisted_2 = { class: "applybtn-tooltip" }

import { ref, computed, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { VoicesMutationTypes as VoicesMutationType } from '@/store/voices/mutations'
import SpeedTabSlider from 'vue-slider-component'
import sliderDataOption from '@/mixins/sliderOptions'
import Button from './UI/Button.vue'
import { addTagsToSelection } from '@/utils/addTagsToSelection'
import CustomTooltip from '@/components/UI/CustomToolTip.vue'

const speedDefault = '1'
const apiMid = 1
const apiMin = 0.25
const apiMax = 4.0
const uiMid = 1
const uiMin = 0.8
const uiMax = 1.2
const tagClass = 'speed'

export default /*@__PURE__*/_defineComponent({
  __name: 'SpeedTab',
  props: {
  disableApplyPlay: {
    type: Boolean
  }
},
  setup(__props) {

const props = __props
const { sliderDataOptions } = sliderDataOption()
const speedValue = ref(1)
const store = useStore()
const { t } = useI18n()
const selection = document.getSelection()
const showTooltip = ref(false)

const speedStore = computed(() => store.state.voices.voiceSpeedValue)

const speedApiValue = computed(() =>
  speedValue.value > uiMid
    ? (((apiMax - apiMid) / (uiMax - uiMid)) * (speedValue.value - uiMid) + apiMid).toFixed(2)
    : speedValue.value < uiMid
      ? (((apiMid - apiMin) / (uiMid - uiMin)) * (speedValue.value - uiMin) + apiMin).toFixed(2)
      : apiMid
)

const disableApplyButton = computed(() => {
  let value = true
  const conditions = addTagsToSelection(selection, speedValue.value, speedDefault, speedApiValue.value, tagClass, t, '')

  if (props.disableApplyPlay == false && speedValue.value != 1) {
    value = false
  }

  if (conditions == false) {
    value = false
  }
  return value
})

const applyEffects = () => {
  if (selection.isCollapsed == true) {
    store.commit(VoicesMutationType.SET_VOICE_SPEED_VALUE, speedApiValue.value)
  }
  addTagsToSelection(selection, speedValue.value, speedDefault, speedApiValue.value, tagClass, t, 'CRUD')
}

watchEffect(() => {
  if (speedStore.value == 1) {
    speedValue.value = 1
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SpeedTabSlider), _mergeProps({
      modelValue: speedValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((speedValue).value = $event)),
      min: 0.8,
      max: 1.2,
      interval: 0.01
    }, _unref(sliderDataOptions)), null, 16, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "applybutton",
        onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (showTooltip.value = true)),
        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (showTooltip.value = false))
      }, [
        _createVNode(Button, {
          text: _ctx.$t('_buttons.apply'),
          buttonType: "speed-tab-apply",
          isDisabled: disableApplyButton.value,
          onOnClick: applyEffects
        }, null, 8, ["text", "isDisabled"])
      ], 32),
      _createVNode(CustomTooltip, {
        style: _normalizeStyle({ opacity: showTooltip.value ? 1 : 0, visibility: showTooltip.value ? 'visible' : 'hidden' }),
        toolTipText: _ctx.$t('_toolTip.effectDisabledToolTipText'),
        disableTooltip: disableApplyButton.value,
        toolTipType: "applybtn"
      }, null, 8, ["style", "toolTipText", "disableTooltip"])
    ])
  ]))
}
}

})